import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

export function initializeKeycloak(keycloak: KeycloakService) {
    return () =>
      keycloak.init({
        config: {
          url: environment.keycloak.url,
          realm: environment.keycloak.realm,
          clientId: environment.keycloak.clientId
        },
        initOptions: {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri:
            environment.keycloak.redirectUrl
        },shouldAddToken: (request) => {
            const { method, url } = request;
            const isPharmaRequest = request.url.includes(environment.pharmaKgb);
            if(isPharmaRequest) return false;
            const isGetRequest = 'GET' === method.toUpperCase();
            const acceptablePaths = ['/assets', '/clients/public'];
            const isAcceptablePathMatch = acceptablePaths.some((path) =>
              url.includes(path)
            );
             
   
          console.log(`Intercepting request to: ${request.url}`);
            return !(isGetRequest && isAcceptablePathMatch);
          },shouldUpdateToken: (request) => {
            const { method, url } = request;

            const isGetRequest = 'GET' === method.toUpperCase();
            const acceptablePaths = ['/assets', '/clients/public'];
            const isAcceptablePathMatch = acceptablePaths.some((path) =>
              url.includes(path)
            );

            return !(isGetRequest && isAcceptablePathMatch);
          }
      });
  }